// app/loading.tsx
import { InlineLoading } from '@carbon/react';
import '@/app/styles/loader-carbon.scss';
export default function Loading() {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        padding: '10px',
        height: '100%',
        width: '100%',
        position: 'relative',
        background: 'transparent',
      }}
    >
      <InlineLoading status="active" description="Loading page..." />
    </div>
  );
}
